export class AuthDataModel {
  TDOCID: string;
  TDOGuid: string;
  access_token: string;
  expires_in: number;
  token_type: string;
  userdisplayname: string;
  userfullname: string;
  userid: string;
  patientid: string;
  doctorId: string;
  usernickname: string;
  userroles: string[];
  webclientid: string;
  WorkStationID: string;
  tzId: string;
  tzOffsetMins: number = 0;
}
